/*
 * Module for the Insurance Carriers edit view
 */

rs.module("fund/configuration/insurancecarriers/edit",

    ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);

            // listen for changes on insurance type checkboxes
            form.js(jsSelectors.typeCheckbox, { multiple: true, required: false }).change(function () {

                // get the corresponding subsidy select for the type checkbox 
                var subsidySelect = form.js(jsSelectors.subsidySelect, { multiple: true, required: false }).filter(`[data-type=${$(this).data("type")}]`);

                // Enable/disable select based on the state of the corresponding checkbox
                selectHelper.getHelper(subsidySelect).setDisabled(!$(this).is(":checked"));

                // if the checkbox is being unchecked, clear the subsidy selection
                if (!$(this).is(":checked")) {
                    selectHelper.getHelper(subsidySelect).selectIndex(0);
                }

            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);